<!--  -->
<template>
      <div style="width:100%;height:100%;position:relative">
      <Nav :navList="navList"></Nav>
      <div id="con">
        <transition name="move">
          <div class="left" v-show="show">
            <div class="info">
              <!-- <img src="@/assets/公司简介.png"/> -->
              <h1>PEPCO<br/>KIDS</h1>
              <h2>{{title}}</h2>
            </div>
          </div>
        </transition>
        <div class="right" id="r">
          <el-carousel :height="th" v-if="imgs==undefined||imgs.length==0">
            <el-carousel-item  v-for="(item) in 1" :key="item">
              <el-image  style=" width:100%;height:100%;display: flex;justify-content: center;align-items: center;" :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'">
                <div slot="error" style="font-size:25px;color:gray">
                    {{message}}
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <el-carousel v-else :height="th">
            <el-carousel-item v-for="item in imgs "  :key="item">
              <el-image :src="item" fit="cover" style=" width:100%;height:100%"></el-image>
            </el-carousel-item>
            <!-- <el-carousel-item>
              <img src="@/assets/公司简介/1.png" style=" width:100%;"/>
            </el-carousel-item> -->
          </el-carousel>
        </div>
      </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from '@/components/Nav'
import {queryTitle,queryImgs} from '@/api/web/company'
import {loadingTime} from '@/utils/const.js'
import 'animate.css'
export default {

components: {Nav},
data() {
//这里存放数据
return {
  navList:['公司简介,/introduction/index','发展历史,/introduction/history','门店分布,/introduction/distribution','门店展示,/introduction/show'],
  th:"",
  show:false,
  title:"请稍等,公司简介信息正在加载中......",
  message:"请稍等,图片信息正在加载中......",
  imgs:[],
  h:0
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
 var _this = this
 let resizeTimer = setInterval(()=>{
  const rEl = document.getElementById("r")
  if(rEl && rEl.offsetHeight>=0){
    if(_this.h<rEl.offsetHeight){
      _this.h += 70;
      if(_this.h>=rEl.offsetHeight){
        _this.th=rEl.offsetHeight+"px"
        clearInterval(resizeTimer)
      }else{
        _this.th=_this.h+"px"
      }
    }
  }
 },20)
window.onresize = () => {
    return (() => {
      const rEl = document.getElementById("r")
      if(rEl) this.th = rEl.offsetHeight+"px";
    })();
  };
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 let _this = this;
 setTimeout(()=>{
  if(_this.title=='请稍等,公司简介信息正在加载中......'||_this.title==undefined||_this.title==null){
    _this.title='公司简介信息加载失败,请刷新页面重试'
  }
  if(_this.imgs.length==0||_this.imgs==undefined||_this.imgs==null){
    _this.message='图片信息加载失败,请刷新页面重试'
  }
 },loadingTime)
 queryTitle().then(({data})=>{
  _this.title=data
 },()=>{
  _this.title='公司简介信息加载失败,请刷新页面重试'
 })
 queryImgs().then(({data})=>{
  _this.imgs=data
  // console.log(_this.imgs)
 },()=>{
  _this.message='图片信息加载失败,请刷新页面重试'
 })
this.show=true
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {
  window.onresize = null;
}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
#con{
  position:absolute;
  display: flex;
  justify-content:space-between;
  width:100%;
  height:100%;
  
  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    padding-top: 50px;
    box-sizing: border-box;
    height: calc(100% - 50px);
  }
}
.right{
  width:56%;
  height:100%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-right: 40px;
  box-sizing: border-box;
  
  @media screen and (max-width: 768px) {
    width:100%;
    height: 45%;
    min-height: 200px;
    padding-right: 0;
  }
}
.left{
  width:44%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media screen and (max-width: 768px) {
    width:100%;
    height: 55%;
    min-height: 200px;
  }
}
.info{
  width:80%;
  height: auto;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    width:90%;
    margin-bottom: 20px;
  }
}
.info h1{
  font-size: 56px;
  margin-bottom: 30px;
  letter-spacing: -2px;
  line-height: 1.2;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    font-size: 42px;
    margin-bottom: 20px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 10px;
    letter-spacing: 0;
  }
}
.info h2{
  font-size: 18px;
  width:100%;
  max-width: 500px;
  text-align: center;
  letter-spacing: 3px;
  line-height: 32px;
  
  @media screen and (max-width: 768px) {
    font-size: 13px;
    text-align: center;
    letter-spacing: 1px;
    line-height: 20px;
    word-break: break-word;
  }
}

.el-carousel{
  border-radius: 60px 0px 0px 60px;
  
  @media screen and (max-width: 768px) {
    border-radius: 20px 20px 0 0;
  }
}

.move-enter-active{
  animation:slideInLeft 0.5s;
}
.move2-enter-active{
  animation:slideInRight 0.5s;
}

@media screen and (max-width: 768px) {
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 2;
    line-height: 150px;
    margin: 0;
    text-align: center;
  }
  /* 轮播指示器：缩小尺寸，强制单行显示（用 ::v-deep 穿透 scoped） */
  ::v-deep .el-carousel__indicators {
    bottom: 8px;
    white-space: nowrap;
  }
  ::v-deep .el-carousel__indicators--outside {
    display: none;
  }
  ::v-deep .el-carousel__indicator {
    padding: 4px 3px !important;
    display: inline-block !important;
  }
  ::v-deep .el-carousel__indicator .el-carousel__button {
    width: 6px !important;
    height: 6px !important;
    margin: 0 1px;
  }
}
</style>